/* a11y remediation — rev 2 (guard + timed re-runs) */
document.addEventListener("DOMContentLoaded", () => {
  const accessibilityLink = document.querySelector(
    'a[href="/pages/accessibility"]'
  );

  if (accessibilityLink) {
    const newElement = document.createElement("li");
    newElement.className = "accessibility-helper";
    newElement.innerHTML = `
        <button onclick="window.interdeal.a11y.openMenu()" class="link link--text list-menu__item list-menu__item--link uppercase" style="text-align:left;">
         Enable Accessibility Options
        </button>
      `;

    accessibilityLink.parentElement.insertAdjacentElement(
      "afterend",
      newElement
    );
  }

  // accessibility fix for owl slide( empty buttons )
  const MAX_RETRIES = 10;
  let retryCount = 0;

  const addAriaLabel = (elemSelector = ".owl-dots") => {
    console.log("setting aria labels");
    const owlContainers = document.querySelectorAll(elemSelector); // Select all owl-dots containers

    if (owlContainers.length > 0) {
      owlContainers.forEach((container) => {
        const owlDots = container.querySelectorAll(".owl-dot"); // Get all dots in the current container
        if (owlDots.length > 0) {
          owlDots.forEach((dot, index) => {
            dot.setAttribute("aria-label", `Go to slide ${index + 1}`);
            // Per auditor: hide the decorative inner <span>, mark the active dot.
            const inner = dot.querySelector("span");
            if (inner) inner.setAttribute("aria-hidden", "true");
            if (dot.classList.contains("active")) dot.setAttribute("aria-current", "true");
            else dot.removeAttribute("aria-current");
          });
        }
      });
      owlContainers.forEach(el => {
        el.setAttribute('tabindex', '0');
      });
    } else if (retryCount < MAX_RETRIES) {
      retryCount++;
      setTimeout(addAriaLabel, 500);
    }
  };

  addAriaLabel();
  document.addEventListener("AddAriaLabelsToOwl", (e) =>
    addAriaLabel(e.detail.element)
  );

  const menuItems = document.querySelectorAll('a[href="#"].list-menu__item');
  menuItems.forEach((menuItem) => {
    menuItem.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        const mouseoverEvent = new Event("mouseover", {
          bubbles: true,
          cancelable: true,
        });
        menuItem.dispatchEvent(mouseoverEvent);

        setTimeout(() => {
          const visibleMegamenu = document.querySelector(
            ".megamenu--isVisible"
          );
          if (visibleMegamenu) {
            const focusableElements = visibleMegamenu.querySelectorAll(
              'a, button, input, select, textarea, [tabindex]:not([tabindex="-1"])'
            );

            if (focusableElements.length > 0) {
              focusableElements[0].focus();

              focusableElements[focusableElements.length - 1].addEventListener(
                "keydown",
                (e) => {
                  if (e.key === "Tab" && !e.shiftKey) {
                    e.preventDefault();
                    document
                      .querySelector(".megamenu--current")
                      .parentNode.nextElementSibling.querySelector("a")
                      .focus();
                  }
                }
              );

              focusableElements[0].addEventListener("keydown", (e) => {
                if (e.key === "Tab" && e.shiftKey) {
                  e.preventDefault();
                  focusableElements[focusableElements.length - 1].focus();
                }
              });
            }
          }
        }, 1000);
      }
    });
  });

  // mega menu
  document.querySelectorAll('.custom-mega-menu').forEach(menu => {
    const summary = menu.querySelector('summary');
    if (!summary) return; // guard: a mega-menu without a <summary> would throw below and halt the rest of this handler (incl. the ADA sweep)
    const headerMenu = menu.closest('header-menu');
    let closeTimeout;
  
    menu.addEventListener('toggle', () => {
      const expanded = menu.open ? 'true' : 'false';
      summary.setAttribute('aria-expanded', expanded);
      headerMenu?.setAttribute('aria-expanded', expanded);
    });
  
    summary.addEventListener('mouseenter', () => {
      clearTimeout(closeTimeout);
      menu.open = true;
      summary.setAttribute('aria-expanded', 'true');
      headerMenu?.setAttribute('aria-expanded', 'true');
    });
  
    menu.addEventListener('mouseleave', () => { 
      closeTimeout = setTimeout(() => {
        menu.open = false;
        summary.setAttribute('aria-expanded', 'false');
        headerMenu?.setAttribute('aria-expanded', 'false');
      }, 250);  
    });
  
    menu.addEventListener('mouseenter', () => {  
      clearTimeout(closeTimeout);
    });
  });
  
  
  //   improve annoucement bar links accessibility
  const menuLinks = document.querySelectorAll(
    ".announcement-bar__menu-link[aria-controls]"
  );

  menuLinks.forEach(link => {
    const dropdownId = link.getAttribute('aria-controls');
    const dropdown = document.getElementById(dropdownId);
   
    link.addEventListener('mouseenter', e => {
      e.preventDefault();
   
      document.querySelectorAll('.announcement-bar__menu-link[aria-expanded="true"]').forEach(openLink => {
        openLink.setAttribute('aria-expanded', 'false');
        const openDropdown = document.getElementById(openLink.getAttribute('aria-controls'));
        if (openDropdown) openDropdown.hidden = true;
      });
  
      link.setAttribute('aria-expanded', 'true');
      if (dropdown) dropdown.hidden = false;
    });
   
    [link, dropdown].forEach(el => {
      if (!el) return;
  
      el.addEventListener('mouseleave', () => {
        setTimeout(() => {
          const linkHovered = link.matches(':hover');
          const dropdownHovered = dropdown && dropdown.matches(':hover');
  
          if (!linkHovered && !dropdownHovered) {
            link.setAttribute('aria-expanded', 'false');
            if (dropdown) dropdown.hidden = true;
          }
        }, 100);
      });
    });
  });
  // yotpo yotpo-pictures-gallery-images-wrapper
  function enhanceYotpoOverlays() {
    const overlays = document.querySelectorAll(
      '.yotpo-pictures-gallery-images-wrapper .y-image-overlay'
    );
  
    overlays.forEach(overlay => {
      if (overlay.dataset.enhanced) return;  
      overlay.dataset.enhanced = true;
  
      overlay.setAttribute('role', 'button');
      overlay.setAttribute('tabindex', '-1');  
      if (!overlay.hasAttribute('aria-label')) {
        overlay.setAttribute('aria-label', 'Open image');
      }
    });
  }
  document.addEventListener('DOMContentLoaded', enhanceYotpoOverlays);

  // Safety net: many role="button" elements are injected by JS/apps AFTER load
  // (slick/swiper/splide carousel dots & arrows, gallery tiles, app widgets) and
  // ship with no accessible name — the recurring ada-4 finding. This labels any
  // that truly have no name yet, deriving a meaningful label from the control's
  // role in the UI (controls that already have a name pass accessibleName and are
  // skipped, so only genuinely nameless ones get labeled).
  function accessibleName(el) {
    // aria-label="" and aria-label="   " are NOT names. Attribute presence alone
    // is not enough -- an empty one is exactly how app-injected icon links ship.
    const label = el.getAttribute('aria-label');
    if (label && label.trim()) return true;

    // aria-labelledby only names the element if the referenced node exists and
    // has text. A dangling id leaves the element unnamed.
    const labelledby = el.getAttribute('aria-labelledby');
    if (labelledby) {
      const named = labelledby.split(/\s+/).some(function (id) {
        const ref = id && document.getElementById(id);
        return ref && ref.textContent && ref.textContent.trim();
      });
      if (named) return true;
    }

    if (el.getAttribute('title') && el.getAttribute('title').trim()) return true;
    if (el.textContent && el.textContent.trim()) return true;
    const img = el.querySelector('img[alt]');
    if (img && img.getAttribute('alt').trim()) return true;
    const svgTitle = el.querySelector('svg title');
    if (svgTitle && svgTitle.textContent.trim()) return true;
    return false;
  }

  // Not in the accessibility tree, so it needs no name.
  function isHiddenFromAT(el) {
    return !!(el.closest('[aria-hidden="true"]') || el.closest('[hidden]'));
  }

  function labelUnnamedRoleButtons() {
    // Covers ada-4/ada-7 ([role=button]) AND ada-9 (plain <button> with no name,
    // e.g. icon-only carousel arrows). Buttons WITH text pass accessibleName and
    // are skipped, so only genuinely nameless ones get labeled.
    // Query all of them and let accessibleName decide -- filtering on attribute
    // presence skips controls carrying an empty aria-label, which are unnamed to
    // an audit but looked labelled to the selector.
    const candidates = document.querySelectorAll('[role="button"], button');
    candidates.forEach((el) => {
      if (accessibleName(el)) return;
      if (isHiddenFromAT(el)) return;
      const cls = (el.className || '').toString().toLowerCase();
      let label = 'Button';
      if (/(^|[\s_-])(dot|bullet|pagination)/.test(cls)) {
        const sibs = el.parentElement
          ? Array.from(el.parentElement.children).filter(
              (c) => c.getAttribute('role') === 'button'
            )
          : [el];
        const idx = sibs.indexOf(el);
        label = idx >= 0 ? `Go to slide ${idx + 1}` : 'Go to slide';
      } else if (/prev/.test(cls)) {
        label = 'Previous slide';
      } else if (/next/.test(cls)) {
        label = 'Next slide';
      } else if (/close/.test(cls)) {
        label = 'Close';
      } else if (/(arrow|nav)/.test(cls)) {
        label = 'Carousel navigation';
      }
      el.setAttribute('aria-label', label);
    });
  }

  // Safety net for ada-5: images injected by JS/apps (Yotpo UGC gallery, etc.)
  // often ship with no alt/aria-label. Give them a meaningful accessible name
  // derived from context. Images the theme controls already have alt, so the
  // :not([alt]) filter skips them, and we never touch an explicit alt="" (which
  // is a valid "decorative" marker the scanner already excludes).
  function labelUnnamedImages() {
    const imgs = document.querySelectorAll(
      'img:not([alt]):not([aria-label]):not([aria-labelledby]):not([role="presentation"]):not([aria-hidden="true"])'
    );
    imgs.forEach((img) => {
      let label = '';
      // Shopify's video_tag emits a poster <img> fallback inside <video> with no
      // alt — it's decorative (the video is the content), so mark it alt="".
      if (img.closest('video')) {
        img.setAttribute('alt', '');
        return;
      }
      const labelledAncestor = img.closest('a[aria-label], [role="button"][aria-label]');
      if (labelledAncestor) {
        // The interactive parent already carries the name; mark the img decorative
        // to avoid a redundant/duplicate announcement.
        img.setAttribute('alt', '');
        return;
      }
      if (img.closest('[class*="yotpo"], .yotpo-pictures-gallery-images-wrapper')) {
        label = 'Customer photo';
      }
      if (!label) {
        const src = img.getAttribute('src') || img.getAttribute('data-src') || '';
        const file = src.split('/').pop().split('?')[0].replace(/\.[a-z0-9]+$/i, '');
        label = file ? file.replace(/[-_]+/g, ' ').trim() : 'Image';
      }
      img.setAttribute('alt', label);
    });
  }

  // Safety net for ada-6: links (<a>) injected by JS/apps (Yotpo gallery tiles,
  // icon links) with no text and no aria-label. Prefer a name from a child img's
  // alt, then a UGC/context label, then the href's last path segment. Runs BEFORE
  // labelUnnamedImages so an image inside a now-labeled link becomes decorative.
  function hrefLabel(a) {
    try {
      const seg = new URL(a.href, location.origin).pathname
        .split('/')
        .filter(Boolean)
        .pop();
      return seg ? seg.replace(/[-_]+/g, ' ').trim() : '';
    } catch (e) {
      return '';
    }
  }

  function labelUnnamedLinks() {
    // Query every link and let accessibleName decide. Filtering on attribute
    // presence skipped links carrying an EMPTY aria-label, which is precisely
    // how several injected widgets render icon links -- they looked labelled to
    // the selector and unnamed to the audit.
    const links = document.querySelectorAll('a');
    links.forEach((a) => {
      if (accessibleName(a)) return;
      if (isHiddenFromAT(a)) return;
      let label = '';
      const img = a.querySelector('img[alt]');
      if (img && img.getAttribute('alt').trim()) label = img.getAttribute('alt').trim();
      if (!label && a.closest('[class*="yotpo"]')) label = 'Customer photo';
      if (!label) label = hrefLabel(a);
      a.setAttribute('aria-label', label || 'Link');
    });
  }

  // Form controls (input/select/textarea) with no associated <label>, aria-label,
  // aria-labelledby or title are flagged for a missing accessible name. Skip
  // submit/button/reset (named by their value) and hidden inputs. Derive a name
  // from placeholder -> name -> type.
  function hasAssociatedLabel(el) {
    if (el.id) {
      try {
        if (document.querySelector('label[for="' + (window.CSS && CSS.escape ? CSS.escape(el.id) : el.id) + '"]')) return true;
      } catch (e) {}
    }
    if (el.closest('label')) return true;
    return false;
  }

  function labelUnnamedFormControls() {
    // Select on the computed name, not attribute presence: aria-label="" is a
    // control with no name, and the :not([aria-label]) form skipped exactly those.
    const controls = document.querySelectorAll(
      'input:not([type="hidden"]):not([type="submit"]):not([type="button"]):not([type="reset"]):not([type="image"]),' +
      'select, textarea'
    );
    controls.forEach((el) => {
      if (hasAssociatedLabel(el)) return;
      if (accessibleName(el)) return;
      if (isHiddenFromAT(el)) return;
      var label = el.getAttribute('placeholder') || el.getAttribute('name') || el.getAttribute('type') || 'Input field';
      label = String(label).replace(/[-_]+/g, ' ').trim();
      el.setAttribute('aria-label', label || 'Input field');
    });
  }

  // One ordered sweep: enhancers first, then buttons, links, images, form controls
  // (so media inside a freshly-named link/button is marked decorative, not double-named).
  // ada-13 / rule 510: elements carrying a widget role that REQUIRES an
  // accessible name. A div[role="combobox"] is not a form control, so none of the
  // labellers above see it -- search widgets injected by apps commonly render one.
  // Prefer a name already present in the control's own markup before falling back
  // to something generic, so screen reader users get something meaningful.
  function labelUnnamedWidgetRoles() {
    const els = document.querySelectorAll(
      '[role="combobox"], [role="searchbox"], [role="listbox"]'
    );
    els.forEach((el) => {
      if (accessibleName(el)) return;
      if (isHiddenFromAT(el)) return;

      let label = '';

      // A label element pointing at it, or wrapping it.
      const id = el.getAttribute('id');
      if (id) {
        const safeId = window.CSS && CSS.escape ? CSS.escape(id) : id;
        const lbl = document.querySelector('label[for="' + safeId + '"]');
        if (lbl && lbl.textContent.trim()) label = lbl.textContent.trim();
      }
      if (!label) {
        const wrapping = el.closest('label');
        if (wrapping && wrapping.textContent.trim()) label = wrapping.textContent.trim();
      }

      // A label inside the widget, or one bound to a control it wraps. App
      // widgets (Yotpo's review filters) put the label on the inner <input>
      // and leave the outer div[role="combobox"] unnamed, so the meaningful
      // text is in there -- much better than falling through to "Combobox".
      if (!label) {
        const innerLabel = el.querySelector('label');
        if (innerLabel && innerLabel.textContent.trim()) label = innerLabel.textContent.trim();
      }
      if (!label) {
        const innerControl = el.querySelector('input[id], select[id], textarea[id]');
        if (innerControl) {
          const cid = innerControl.getAttribute('id');
          const safeCid = window.CSS && CSS.escape ? CSS.escape(cid) : cid;
          const l = document.querySelector('label[for="' + safeCid + '"]');
          if (l && l.textContent.trim()) label = l.textContent.trim();
        }
      }

      // Its own placeholder, or one on an input it contains.
      if (!label) label = (el.getAttribute('placeholder') || '').trim();
      if (!label) {
        const inner = el.querySelector('input[placeholder], input[aria-label]');
        if (inner) {
          label = (inner.getAttribute('aria-label') || inner.getAttribute('placeholder') || '').trim();
        }
      }

      if (!label) {
        const hint = ((el.className || '') + ' ' + (id || '')).toString().toLowerCase();
        const role = el.getAttribute('role');
        if (hint.indexOf('search') !== -1 || role === 'searchbox') label = 'Search';
        else if (role === 'listbox') label = 'Options list';
        else label = 'Combobox';
      }

      el.setAttribute('aria-label', label);
    });
  }

  function runAdaSweep() {
    enhanceYotpoOverlays();
    labelUnnamedRoleButtons();
    labelUnnamedLinks();
    labelUnnamedImages();
    labelUnnamedFormControls();
    labelUnnamedWidgetRoles();
  }

  runAdaSweep();
  document.addEventListener('AddAriaLabelsToOwl', runAdaSweep);

  // Re-run when the DOM changes, debounced so async app injection is caught without
  // thrashing the main thread. Setting attributes (aria-label/alt) is not a childList
  // change, so this observer won't re-trigger itself.
  let sweepTimer = null;
  const observer = new MutationObserver(() => {
    if (sweepTimer) return;
    sweepTimer = setTimeout(() => {
      sweepTimer = null;
      runAdaSweep();
    }, 250);
  });
  observer.observe(document.body, { childList: true, subtree: true });

  // Third-party widgets (Yotpo UGC gallery, Bloomreach popups) render well after
  // DOMContentLoaded, and an A11y scanner may snapshot before the MutationObserver
  // debounce fires. Re-sweep on load and a few times after so their injected
  // buttons/links/images get an accessible name before the next scan.
  window.addEventListener('load', runAdaSweep);
  [800, 2000, 4000, 7000, 10000].forEach(function (t) { setTimeout(runAdaSweep, t); });

});
